<script lang="ts">

/* 
For dislaying and entry element, that can also be edited when clicked
*/

import DataBaseTests from '@/ts/DataBaseTests';
import Entry, { EntryDB } from '@/ts/DataTypes/Entry';
import { defineComponent, handleError } from 'vue'


import DatePicker from './DatePicker.vue';
import InputTextSmart from './InputTextSmart.vue';
import type {ObjectIn} from './InputTextSmart.vue';
import TimePicker from './TimePicker.vue';

// import Data from '../ts/Data';
import  { EntryAttributeDB, UserDB, type ItemTypeDB } from '@/ts/DexieDB';
import StaticVars, { ModalInfo } from '@/ts/StaticVars';
import AttributeVue from './Attribute.vue';
import { CatDB } from '@/ts/DataTypes/CategoryData';
import ButtonGroupVue, { ButtonInfo } from './ButtonGroup.vue';
import CategoryData from '@/ts/DataTypes/CategoryData';
import Button from './Button.vue';

export default defineComponent({
    components: { Button, DatePicker, TimePicker, InputTextSmart, AttributeVue, ButtonGroupVue },
    props:
    {
        //have to set to required, or typescript complains it could be undefined, and won't allow you to use it...
        entry:{type:Entry, required:true}, //vue/ typescript doesn't see the entry being passed in as an entry....
        // entry:{type:Object, required:true}, //we are passing it in as an entry, but for some reason vue/ typescript doesn't like it....
        extra_info:Object,
        DeleteEntryClicked:{ type:Function, required:true},
        AddOrEditEntry:{ type:Function, required:true},


        // Close:{ type:Function, required:true},


        // SwitchScreen: { type: Function, required:true},
        BackButtonRegister: { type: Function, required:true },
        MoveForwardToPage: { type: Function, required:true },
        MoveBack: { type: Function, required:true },
        is_new_screen:{type:Boolean, required:true},// to know whether we need to switch screen, or just close parent (since can exist on individual page or in entry list)


        parent_screen:{ type:Number, default:StaticVars.SCREENS.HOME}, //to know which one to go back to if we edit a cat- if editing from entry list, leave that screen up, if from new entry, leave that one up

        //for attributes to be able to confirm being deleted
        ShowModal:{ type:Function, required:true},//have to give it a default value, or typescript thinks it could be undefined...,
        is_new_entry:{ type:Boolean, default:false},

        // recent_entries:{type:Array<EntryDB>, default: []}
        cats:{ type:Array<CategoryData>, required:true},
        GetPrevEntriesForCat:{ type:Function, required:true},
        GetPrevAttributesForCat:{ type:Function, required:true},
        AttributeCreateUpdateOrDelete:{ type:Function, required:true},
        // user:{type:UserDB, required:true},

        

  },
  data() 
  {
    return {
        // editing:false,

        //so that it can update the date and time components when one of these changes, since it can't update when entry.date changes
        date_updated:undefined,
        date_finished:undefined,
        prev_item_types:new Array<ItemTypeDB>(), //for previous entries to be sent to smart input

        attributes:new Array<EntryAttributeDB>(), //for the attributes on this entry

        prev_attributes:new Array<EntryAttributeDB>(), //for previous entries to be sent to smart input
        // prev_attr_names:new Array<ObjectIn>(),
        // prev_attr_values:new Array<ObjectIn>(),

        entry_name_changed:false,//to record if an entry was changed, so have to update it
        date_changed:false, //to record if a date/time updated, or finished changed, to update it
        has_duration:false, //original value for has_duration- to check if it was changed
        tracking:false, //for tracking the entry time elapsed
        elapsed_time:"",
        elapsed_time_interval:undefined,

        original_cat_id:"-1", //for tracking if the category changed
        entry_editable: new Entry({}), //to store the changes to the entry, without affecting the original entry in case we cancel

        force_vue_update_on_attr:0, // for
        //for updating the cats area when new ones have been added/ old ones have changed
        key_force_cat_update:0,



        cats_for_new_entry:Array<CategoryData>(),
        btn_info_for_cats:Array<ButtonInfo>(),

        loaded:false, //for making sure the children components don't mount before this component mounts

        entry_inputs:[{key:0, entry:null}], //for allowing more than one entry - so could put all the pills in on one screen, all at the same time. //Entry is for populating it with an existing entry, like when creating a new one because a previous one was clicked

    }
  },

  async mounted()
  {
    if(this.is_new_screen)
        this.BackButtonRegister(this.Back);

    this.loaded=true;

    // console.log("DEBUG CAT ENTRIES, Data.cats[1].entries : ",Data.cats[1].entries );
    this.entry_editable = new Entry({...this.entry});
    // console.log("Entry:  ", this.entry)


    console.log("Entry mounted, this this.entry_editable.date_updated: ", this.entry_editable.date_updated, "extra_info: ", this.extra_info);
    this.date_updated=this.entry_editable.date_updated as unknown as undefined;
    this.date_finished=this.entry_editable.date_finished as undefined;
    

    if(!this.date_updated)
        this.date_updated = (new Date()as unknown  as undefined);
    console.log("Entry Editable "+this.entry_editable.item_type+", this date updated: ", this.date_updated, "this finished: ", this.date_finished);

    this.tracking=this.entry.tracking;

    if(!this.is_new_entry)
    {
        await this.SetupForExistingEntry();
    }
    else
    {
        // console.log("EntryEditable: SetupForNewEntry: entry_editable", this.entry_editable, "cats_for_new_entry: ", this.cats);
        //have to have a default cat id for the next part
        // this.entry_editable.id_cat=this.cats[0].id;
        //though should still have the plus sign if no cats
        await this.SetupForNewEntry();
    }
    // console.log("DEBUG CAT ENTRIES, Data.cats[1].entries : ",Data.cats[1].entries );

    //do a timer for elapsed time


        this.ElapsedTime();//fire before the first second/ already mounted
        this.elapsed_time_interval = (setInterval(() => 
        {
            if(!this.date_finished)
                this.ElapsedTime();
        }, 1000) )as unknown as undefined ;


        console.log("EntryEditable Mounted, this.date_finished: ", this.date_finished, "!date_finished? :", (!this.date_finished));
        
   
  },
  beforeUnmount()
  {
    console.log("beforeUnmount, destroying interval timer!")
    clearInterval(this.elapsed_time_interval);
    }   ,
    computed: 
    {
        GetCats() 
        {

        },
        

    },

  methods:{
    ElapsedTime()
    {
        if(!this.tracking)
            return;
        //second example from: https://stackoverflow.com/questions/13903897/javascript-return-number-of-days-hours-minutes-seconds-between-two-dates
        
        // let dateFuture = (this.date_finished as unknown as Date).getTime();
        
        let dateFuture = new Date().getTime();
        if(this.date_finished)
            dateFuture = this.date_finished;

        let dateNow = (this.date_updated as unknown as Date).getTime();
        var seconds = Math.floor((dateFuture - (dateNow))/1000);
        var minutes = Math.floor(seconds/60);
        var hours = Math.floor(minutes/60);
        var days = Math.floor(hours/24);

        console.log("days: ", days);
        hours = hours-(days*24);
        minutes = minutes-(days*24*60)-(hours*60);
        seconds = seconds-(days*24*60*60)-(hours*60*60)-(minutes*60);
        this.elapsed_time = (days>0?days+" Days ":"")+
                            (hours>0?hours+" Hr ":"")+
                            (minutes>0?minutes+" Min ":"")+
                            (seconds>0?seconds+" Sec ":"");
        // console.log("elapsed time: ",this.elapsed_time)
        // return elapsed_time;
        //return how much time has passed since time start and end- should grab from task tracker
        // return this.date_finished - this.date_updated.Get;
    },
    async SetupForExistingEntry()
    {
        
        //doesn't fully copy over correctly- still leaves references for attributes, so need to create new versions of them
        this.entry_editable.attributes = [];
        for (let i = 0; i < this.entry.attributes!.length; i++) 
        {
            const element = this.entry.attributes![i];
            this.entry_editable.attributes.push(new EntryAttributeDB().Assign({...element}))

            console.log("EntryEditable: attribute["+i+"]: ",element);
            // this.entry_editable.attributes![i] = new EntryAttributeDB().Assign({...element});
        }
        


        this.has_duration=this.entry_editable.has_duration;
        this.original_cat_id = this.entry_editable.id_cat;
         //grab previous entries from database to auto complete the entry name/ item_type
        //get item type in category (no offset, 10 items)
        let prev_item_types_obj = await this.GetPrevEntriesForCat(this.entry_editable.id_cat);




        //have to have all the cats setup already like we do for new entry
        await this.SetupCategories();
        
        console.log("selecting category id: ", this.entry_editable.id_cat)
        this.SelectCategoryById(this.entry_editable.id_cat);

        // let strings = await prev_entries_obj.map((item_type)=>{return item_type.name});
        // console.log("strings ", strings);
        // this.prev_entries = strings;
        this.prev_item_types  = prev_item_types_obj;


        await this.UpdatePrevAttributesForCat();
        this.attributes = this.entry_editable.attributes || [];
        this.force_vue_update_on_attr+=10;

        


        //do this at the end to try to force the sub input text fields to update when this updates:


        // StaticVars.ForceVueUpdate(this, this.prev_attributes, "prev_attributes");
        // this.prev_attributes = Object.assign({},this.prev_attributes);
        // this.prev_attributes = [];
    },
    async UpdatePrevAttributesForCat()
    {
        let prev_attributes_obj = await this.GetPrevAttributesForCat(this.entry_editable.id_cat);
        if(prev_attributes_obj)
            this.prev_attributes  = [...prev_attributes_obj];

        console.log("done updating prev attributes for cat");

        //should discard duplicates
        // let prev_attributes_obj_no_dups = new Array<EntryAttributeDB>();
        // for (let i = 0; i < prev_attributes_obj.length; i++) 
        // {
        //     const prev_attr = prev_attributes_obj[i];

        //     //going to allow duplicates for now- should get rid of them for auto complete, but not for displayijng- should be able to have duplicate attribute names

        //     let attr_exists=false;
        //     for (let j = 0; j < prev_attributes_obj_no_dups.length; j++) 
        //     {
        //         const prev_attr_no_dup = prev_attributes_obj_no_dups[j];
        //         if(prev_attr_no_dup.name==prev_attr.name)
        //         {
        //             attr_exists=true;
        //             break;
        //         }            
        //     }
        //     if(!attr_exists)
        //         prev_attributes_obj_no_dups.push(prev_attr);
            
        // }
        // console.log("got rid of duplicates, final array: ", prev_attributes_obj_no_dups, "but was: ", prev_attributes_obj);



        // let prev_atrr_names= new Array<ObjectIn>();
        // let prev_atrr_values= new Array<ObjectIn>();
        // for (let i = 0; i < prev_attributes_obj_no_dups.length; i++) 
        // {
        //     const attr = prev_attributes_obj_no_dups[i];
        //     prev_atrr_names.push(new ObjectIn().Init(attr.id as number, attr.name, attr.date_updated));
            
        //     if(attr.value)
        //         prev_atrr_values.push(new ObjectIn().Init(attr.id as number, attr.value as string, attr.date_updated));

        // }
        // console.log("Entry editable prev_attributes ", this.prev_attributes);
        // console.log("Entry editable prev_atrr_names ", prev_atrr_names[0]);

        // this.prev_attributes  = [...prev_attributes_obj_no_dups];
        // this.prev_attr_names = [...prev_atrr_names, { id: 2, name: "Consistancy2", date_updated: new Date() }];
        // this.prev_attr_names = [...prev_atrr_names];
        // this.prev_attr_values = [...prev_atrr_values];
    },
    async SetupForNewEntry()
    {
        let extra_info = (this.extra_info!.entry as Entry);
        // console.log("SetupForNewEntry, extra info: ", extra_info)
        // extra_info.id_user=this.user.id;
        

        //should display a list of potential entries from previous entries for this user
        if(this.entry_editable.id_cat)
        {
            let entries = await this.GetPrevEntriesForCat(this.entry_editable.id_cat);
            this.prev_item_types = entries;
        }
        else
            console.warn("skipping settings up entry editable for new entry, since id_cat is undefined")

            await this.SetupCategories();

            await this.SelectCategoryByIndex(0);

            this.original_cat_id = this.entry_editable.id_cat;
        

    },
    async SetupCategories()
    {
        // console.log("DEBUG CAT ENTRIES, Data.cats[1].entries : ",Data.cats[1].entries );
        //get all the cats too, to have them pick one
        // this.cats_for_new_entry = await Data.GetCategories(this.user.id);
        this.cats_for_new_entry = [...this.cats];

        let cats_sorted = await this.SortByLastUpdated(this.cats_for_new_entry);

        // console.log("DEBUG CAT ENTRIES, Data.cats[1].entries : ",Data.cats[1].entries );
        let btn_info = new Array<ButtonInfo>();
        for (let i = 0; i < cats_sorted.length; i++) 
        {
            const cat = new CategoryData(cats_sorted[i]);

            //should sort based on last date_updated
            btn_info.push(new ButtonInfo({text:cat.name, icon:cat.icon, 
                                            color_bg:cat.color_bg, color_txt:cat.color_txt, extra_info:{id_cat:cat.id, cat:cat/* , date_updated:cat.date_updated */},
                                            hold_for_callback:true, 
                                            callback_held:this.CatHeld
                                        }));            
        }
        // console.log("DEBUG CAT ENTRIES, Data.cats[1].entries : ",Data.cats[1].entries );

        //Also add one for New Category
        btn_info.push(new ButtonInfo({icon:"add_circle", color_bg:"green", extra_info:{type:"add"}}));            

        this.btn_info_for_cats= btn_info;
        console.log("SetupCategories: finished, this.btn_info_for_cats: ",this.btn_info_for_cats)
    },
    async SortByLastUpdated(cats:Array<CategoryData>)
    {
        //https://stackoverflow.com/questions/10123953/how-to-sort-an-object-array-by-date-property
        let new_array = [...cats];
        new_array.sort(function(a,b)
        {
            return b.date_updated.getTime() - a.date_updated.getTime();
        });
        return new_array;
    },
    DeleteClicked(extra_info:any)
    {
        extra_info.predelete = this.PreDeleteElement
        this.DeleteEntryClicked(extra_info);
    },
    //for some reason when we remove the entry from the array, vue puts the editing flag onto the next rendered element... so need to reset this vue element, because it applies the data to the next rendered element for some reason...
    PreDeleteElement()
    {
        console.log("pre delete element called!")
        // this.editing=false;
    },
    
    EntryClicked()
    {
        // this.editing=true;
        console.log("entry clicked!");
        //should make it editable/ change it out with input box to edit name

        //should also let the parent know, to change any being edited to no longer being edited
    },
    DateStartedChanged(date:Date)
    {
        console.log("EntryEditable: DateStartedChanged ", date);
        this.date_changed=true;
        this.entry_editable.date_updated=date;
        // alert("DateStartedChanged, "+date);
        

        this.date_updated=this.entry_editable.date_updated as unknown as undefined;

        // this.key_to_force_update+=1;
        //should let the other elements know as well- if time changed, doesn't change the date on date
        this.ElapsedTime();//to update elapsed time instantly
    },
    DateFinishedChanged(date:Date)
    {
        console.log("EntryEditable: DateFinishedChanged ", date);
        this.date_changed=true;
        this.entry_editable.date_finished=date;
        this.date_finished=this.entry_editable.date_finished as unknown as undefined;
        this.ElapsedTime();//to update elapsed time instantly
    },
    EntryNameChanged()
    {
        //should store the new value for entry
        this.entry_name_changed=true;

    },
    AttributeNameChanged(text:string, attr:EntryAttributeDB)
    {
        console.log("AttributeNameChanged, text: ", text, "attr: ", attr);
        //should change it in this.extra info


    },
    AttributeValueChanged(text:string, attr:EntryAttributeDB)
    {
        console.log("AttributeValueChanged, extra info: ", text, "attr: ", attr);

    },
    Back(SwitchScreen:Function)
    {
        if(this.is_new_screen)
            SwitchScreen(StaticVars.SCREENS.HOME);
        else//if the parent isn't a new screen/ is entry list/ entry element- just call the close function instead of the switch screen function
            this.MoveBack();

    },
    async EditSubmitted(extra_info:any)
    {
        // (extra_info.entry as Entry).Assign(this.entry_editable);
        console.log("Entryeditable, tracking maybe changed to: ", this.tracking, " from: ", this.entry.tracking);

        let inputs = (this.$refs.text as typeof InputTextSmart);
        console.log("input : ", inputs);

        if(this.is_new_entry)
        {
            let entries = [];
            for (let i = 0; i < inputs.length; i++) 
            {
                const input = inputs[i];

                if(!input.GetText())
                {
                    if(inputs.length==1)
                    {
                        this.ShowModal({text:"You cannot have a blank entry name [ entry num "+(i+1)+" ]", only_one_btn:true});
                        return;
                    }
                    else
                    {
                        continue;
                    }
                }

                let entry  = {...extra_info.entry}  as Entry;
                entry.item_type=input.GetText();
                entry.id_item_type=input.item_selected.id;

                entry.date_updated = this.date_updated as unknown as Date;
                entry.date_finished = this.date_finished;
                entry.tracking = this.tracking;
                //await this.CheckIfAttributesChangedAndUpdate(extra_info);
                entry.has_duration = this.has_duration;

                entry.id_user=this.entry.id_user;
                entries.push(entry);
            }

            console.log("going to add entries: ", entries);

            if(entries.length>0) //if there's at least one entry
                await this.AddOrEditEntry(entries);
            else //if there's no entries, but above it checked if there is multiple inputs at least, means that there's multiple inputs that didn't get filled out
            {
                this.ShowModal({text:"You cannot have all blank entry names, num: "+inputs.length, only_one_btn:true});
                return;
            }
            
            // await this.AddOrEditEntry(extra_info.entry);

        }
        else //check for updating instead of adding new
        {
            let input = inputs[0];

            
            if(!input.GetText())
            {
                if(!this.is_new_entry)
                    this.ShowModal({text:"You must have an entry name to update it", only_one_btn:true});
                else
                    this.ShowModal({text:"You must have an entry name to create a new one.", only_one_btn:true});

                return;

            }
            let entry_changed=false;
            // let attributes_changed=false;

            if(this.entry_name_changed)
            {
                entry_changed=true;

                console.log("entry name changed, going to try to update");

                (extra_info.entry as Entry).item_type=input.GetText();
                (extra_info.entry as Entry).id_item_type=input.item_selected.id;
                
                this.entry_editable.item_type=input.GetText();
                this.entry_editable.id_item_type=input.item_selected.id;
            }
            if(this.entry_editable.id_cat!=this.original_cat_id)
            {
                entry_changed=true;
                console.log("Entry category had changed, from: ", this.original_cat_id, " to ", this.entry_editable.id_cat);
            }
            if(this.date_changed)
            {
                console.log("Entry date had changed, from: date finished: ", (extra_info.entry as Entry).date_finished, " to ", this.date_finished);

                entry_changed=true;

                (extra_info.entry as Entry).date_updated = this.date_updated as unknown as Date;
                (extra_info.entry as Entry).date_finished = this.date_finished;
                
                this.entry_editable.date_updated = this.date_updated as unknown as Date;
                this.entry_editable.date_finished = this.date_finished;
            }
            if(this.tracking!=this.entry.tracking)
            {
                console.log("Entryeditable, tracking changed to: ", this.tracking, " from: ", this.entry.tracking);
                entry_changed=true;
                this.entry_editable.tracking = this.tracking;
            }
            
                

        /*  if(this.CheckIfAttributesChanged(extra_info))
            {
                // entry_changed=true;
                attributes_changed=true;
                console.log("attribute was changed, extra info: ", extra_info)
            } */
            await this.CheckIfAttributesChangedAndUpdate(extra_info);

            if(this.has_duration!=this.entry_editable.has_duration)
            {
                this.entry_editable.has_duration = this.has_duration;
                entry_changed=true;
            }
            
            if(entry_changed)
            {
                //for some reason, missing user id and item_type
                if(this.is_new_entry)
                {
                    this.entry_editable.id_user=this.entry.id_user;
                    // this.entry_editable.id_item_type=
                }

                extra_info.entry = this.entry_editable;
                console.log("EditSubmitted1! extra_info.entry: ",extra_info.entry, "this.entry_editable", this.entry_editable);
                //should also update the reference for the entry in memory, so it updates in the entry list
                this.entry.Assign(this.entry_editable);

                console.log("EditSubmitted!", extra_info.entry, "extra_info: ", extra_info, "extra info name: ", extra_info.entry.name);

                
                // this.AddEntry(extra_info);

                //current one
                await this.AddOrEditEntry([extra_info.entry]);
                

                //just for testing
                // if(!this.is_new_entry)
                //     this.editing=false;
                    
            }
            else
                console.log("entry not changed, not going to try to update");

        }
        

        // if(attributes_changed)
        // {
        //     await this.AddAttribute(extra_info.entry);
        // }

        //just for testing
        // if(!this.is_new_entry)

        console.log("Closing entry editable!!\n\n")
        //need to pop the stack instead
        // this.Back(this.MoveBack);
        this.BackOutOfScreen();
        
        //should edit the name of the entry, and let the parent know to update the UI
    },
    async CheckIfAttributesChangedAndUpdate(extra_info:any)
    {
        let any_attribute_added_changed_or_deleted=false;

        let attributes_added_or_changed=new Array<any>();
        let attributes_removed=new Array<any>();
        // let attributes_changed=new Array<any>();
        //so for attributes- should just get all the ones in the UI, then get the values, and compare them to the ones before, 
        //add new ones to the entry, delete ones missing, and edit values for existing ones

        //first get all the attributes input values on screen
        // Object.keys(this.$refs).forEach(el => 
        // {
        //     console.log( this.$refs[el][0] )
        // });
        // console.log(this.$refs)

        //should check the current attributes, see if any have changed

        let attrs_comps = this.$refs.attributes as Array<typeof AttributeVue>;
        if(attrs_comps)
        {
            let new_attrs= new Array<EntryAttributeDB>(); //to add any new attributes to
            for (let i = 0; i < attrs_comps.length; i++)
            {
                // let changed= false;
                const attr = attrs_comps[i];
                // console.log("attribute: ", attr);
                let name = (attr.GetName() as ObjectIn).name;
                let value = (attr.GetValue() as ObjectIn).name;
                let rating = attr.GetRating();

                

                let attr_original = attr.GetAttrOrig() as EntryAttributeDB;
                console.log("attribute values: ", attr.GetName(), attr.GetValue(), attr.GetRating(), "attr_original: ", attr_original);


                //check if everything is blank, and skip it if it is
                //-should only do this if it is a new attribute- if it's an existing one, we should delete it/ blank it out
                // if(!name&&!value&&rating==-1&& !attr_original)
                //     continue;

                //now can update those attributes in the entry, and save it
                let entry_attrs = this.entry_editable.attributes;

                //special case- if we hit submit twice while testing, it adds the new attributes multiple times- should make sure the name and value with -1 isn't already in there
                let new_attr_already_submitted=false;

                // let attr_updated=true;
                let existing_attr=undefined as any;
                if(entry_attrs) //could have no entries
                {
                    for (let j = 0; j < entry_attrs.length; j++) 
                    {
                        const e_attr = entry_attrs[j];

                        //possible states:
                        //Found, unchanged name and value
                        //Found, changed name [ will be new attribute]
                        //found, changed value or rating [will modify existing attribute]
                        //not found [new attribute])

                        //first check if found or unfound

                        if(e_attr.id==attr_original.id)
                        {
                            if(e_attr.id!="-1")//if not a new attribute
                            {
                                console.log("found existing attr id, old name, new name: ", e_attr.name, name );
                                existing_attr= e_attr;
                               
                                break;
                            }
                            else
                            {
                                console.log("found new attribute without id e_attr: ", e_attr, "attr_original", attr_original);
                                if(e_attr.name==attr_original.name && e_attr.value==attr_original.value&& e_attr.rating==attr_original.rating)
                                    new_attr_already_submitted=true;
                            }
                        }
                    }
                }

                if(existing_attr)//if existing id found
                {
                    let attribute_modified=false;
                    // console.log("existing_attr, name was: ", attr_original.name,"now is", name);
                    // console.log("existing_attr, name was: ", attr_original.value,"now is", value);
                    //update anything that has changed
                    if(attr_original.name!==name)
                    {
                        console.log("attr changed, name was: ", attr_original.name,"now is", name);
                        existing_attr.name=name;
                        attribute_modified=true;                    
                    }
                    if(attr_original.value!==value)
                    {
                        console.log("attr changed, value was: ", attr_original.value,"now is", value);
                        existing_attr.value=value;
                        attribute_modified=true;
                    }
                    if(attr_original.rating!==rating)
                    {
                        console.log("attr changed, rating was: ", attr_original.rating,"now is", rating);
                        existing_attr.rating=rating;
                        attribute_modified=true;
                    }
                    if(attribute_modified)
                        attributes_added_or_changed.push(existing_attr);
                }
                else if(!new_attr_already_submitted)//it's a new atribute, and not the 2nd time hitting the submit button
                {
                    //if there were no attributes before, need to create a new array for them
                    if(!this.entry_editable.attributes)
                        this.entry_editable.attributes = new Array<EntryAttributeDB>();
                    

                    let entry_attrs = this.entry_editable.attributes;

                    let name = attr.GetName().name;
                    let value = attr.GetValue().name;
                    let rating = attr.GetRating();
                    console.log("new attribute found! ", attr, `name, value, rating: ${name},  ${value},  ${rating}`)
                    //so have to add it, but with the id being unknown/ -1, which dexie will have to generate
                    entry_attrs?.push(new EntryAttributeDB().CreateAttributeFromEntry(extra_info.entry as Entry).Create(name, value, rating ));
                    console.log("new attribute found! ", entry_attrs![entry_attrs!.length-1], "added it to entry attributes: ", entry_attrs );
                    // changed=true;

                    attributes_added_or_changed.push(entry_attrs[entry_attrs.length-1]);
                }

                
                

                // console.log(attr.querySelector(".name"));

                // console.log(this.$refs.name[i].value);
                // console.log(this.$refs.value[i].value);
                // console.log(this.$refs.rating[i].value);
            }
            if(attributes_added_or_changed.length>0)
                any_attribute_added_changed_or_deleted=true;

            //also should check if an existing attribute has been deleted
            let prev_attrs = this.entry_editable.attributes;

            if(prev_attrs) //could have no entries
            //have to go backwards to remove it
                // for (let i = 0; i < prev_attrs.length; i++) 
                for (let i = prev_attrs.length-1; i >-1 ; i--) 
                {
                    const prev_attr = prev_attrs[i];
                    let prev_id = prev_attr.id;
                    let found=false;
                    for (let j = 0; j < attrs_comps.length; j++)
                    {
                        const new_attr_vue = attrs_comps[j];
                        let new_id = new_attr_vue.attr.id;
                        if(new_id==prev_id)
                        {
                            found=true;
                            break;
                        }
                    }
                    if(!found)
                    {
                        console.log("Didn't find previous attribute: ", prev_attr.name,prev_attr.value, "must have been deleted!");
                        //works, but only bug is for deleting duplicate entries- shouldn't do that, because if they have 2 that are the same name, should be allowed- but will allow autocomplete unfortunately

                        //should remove it from the prev_attrs
                        // entry_attrs?.push(new EntryAttributeDB().CreateAttributeFromEntry(extra_info.entry as Entry).Create(name, value, rating ));
                        //modifies the array, returns the removed item
                        prev_attrs.splice(i,1);

                        attributes_removed.push(prev_attr);

                        any_attribute_added_changed_or_deleted=true;
                    }                
                }
        }


        if(!any_attribute_added_changed_or_deleted)
            console.log("attributes not changed");
        else
        {
            if(attributes_added_or_changed.length>0)
            {
                console.log("attributes ADDED or changed! ", attributes_added_or_changed);
                // console.warn("Need to submit to server");
                this.AttributeCreateUpdateOrDelete(attributes_added_or_changed, "create");
            }
            // if(attributes_changed.length>0)
            // {
            //     console.log("attributes changed! ", attributes_changed);
            //     console.warn("Need to submit to server");
            //     this.AttributeCreateUpdateOrDelete(attributes_changed, "update");
            // }
            if(attributes_removed.length>0)
            {
                console.log("attributes removed! ", attributes_removed);
                
                this.AttributeCreateUpdateOrDelete(attributes_removed, "delete");
            }

            // await this.AddAttribute(extra_info.entry);
        }
        // console.log(this.$refs.name[0].value);
        // console.log(this.$refs.attributes)

        return any_attribute_added_changed_or_deleted;

    },
    GetPreviousAttributesForCat()
    {
    },
    StopEditing()
    {
        console.log("EntryEditable: editing = false");
        // this.editing=false;

        // this.Back(this.MoveBack);
        this.BackOutOfScreen();
    },
    BackOutOfScreen()
    {
        if(this.is_new_screen)
            history.back();
        else
            this.MoveBack();
            
    },
    //add a new attribute to the list of attributes
    AddAttributeClicked()
    {
        let new_attr = new EntryAttributeDB().CreateAttribute(this.entry_editable.id_cat, this.entry_editable.id_item_type, this.entry_editable.id, this.entry_editable.id_user);
        
        this.attributes = [...this.attributes, new_attr];
        //should also focus on the name of this new attribute- probably on next tick
        this.$nextTick(()=>{
            let attrs_comps = this.$refs.attributes as Array<typeof AttributeVue>;
            console.log("attrs_comps: ", attrs_comps);
            console.log("attrs_comps[attrs_comps.length-1]: ", attrs_comps[attrs_comps.length-1]);
            attrs_comps[attrs_comps.length-1].Focus();
        });

    },
    //for attributes to call to allow them to be deleted
    async DeleteAttribute(attr_vue:typeof AttributeVue)
    {
        let attr= attr_vue.attr;

        //vue doesn't care if the key is changed/ unique
        // attr_vue.key=attr_vue.index+", "+attr.id+", "+attr.name;

        console.log("EntryEditable, called Delete Attribute, deleteing attribute: ", attr, "index: ", attr_vue.index);
        //attribute could be a new one, that doesn't exist in the database yet- in that case, just delete the UI
        // if(attr.id==-1)
        // {
            // console.log("going to delete attr that doesn't exist yet");
            console.log("going to delete attr", attr_vue, attr_vue.attr);

            //filter out the new attribute

            //also need to delete it from the Database
            //actually shouldn't- we haven't saved it yet....
            // await Data.DeleteAttribute(attr_vue.attr);


            //doesn't work right/ deletes the right one, but vue deletes the wrong one
            // this.prev_attributes = this.prev_attributes.filter(
            // (exist_attr, index)=>
            // {
            //     console.log("looking at", exist_attr," and index: ", index, "against deleting index: ",attr_vue.index )
            //     //remove it based on trhe index
            //     if(index!=attr_vue.index)
            //         return exist_attr;
            //     else
            //         console.log("deleting index: ",index,"exist_attr: ", exist_attr);
            // })

            let attributes_new = [];
            for (let i = 0; i < this.attributes.length; i++) 
            {
                const exist_attr = this.attributes[i];
                if(i!=attr_vue.index)
                    attributes_new.push(exist_attr);                
            }
            this.attributes = [...attributes_new]
            console.log("new attributes: ", this.attributes)

            //NOTE: only way to force vue to update the array correctly- otherwise it just removes the last item on the list
            console.log("changing key on parent so vue doesn't just delete last item- even if array is new, and correct, vue will just truncate end item on array if shrunk");
            this.force_vue_update_on_attr+=10;
        // }
        // else
        // {
        //     console.log("going to delete attr that does exist");

        //     //so have to delete it in database
        // }
    },

    //for when a cat has been held/ right clicked/ triggered for editing
    CatHeld(extra_info:any)
    {
        //cat ispassed over from button data
        console.log("going to edit cat", extra_info, extra_info.cat);

        this.MoveForwardToPage(StaticVars.SCREENS.CAT_EDIT,{last_screen:StaticVars.SCREENS.ENTRY_INPUT, cat:extra_info.cat})
    },

    //for re-registering the back button after goign to child page
    ReRegisterBackBtn()
    {
        if(this.is_new_screen)
        {
            console.log("EntryEditable: ReRegisterBackBtn");
            this.BackButtonRegister(this.Back);
        }
    },


    async CategoryChanged(btn_info:ButtonInfo)
    {
        console.log("Category changed to: ", btn_info.text, btn_info);
        if((btn_info.extra_info as any).type=="add")
        {
            console.log("going to be adding new category!!");

            //so should open up the editCat screen- based on edit user screen
            //screen and extra data- should send cat info if editing, or blank if creating a new one

            
            this.MoveForwardToPage(StaticVars.SCREENS.CAT_EDIT,{last_screen:StaticVars.SCREENS.ENTRY_INPUT, 
                    //if the cats were changed, call this function to update the UI
                    /* UpdateCatsChanged:this.SetupCategories() */})
        }
        else
        {
            let extra_info = ((this.extra_info as any).entry as Entry)
            extra_info.id_cat = (btn_info.extra_info as any).id_cat;
            console.log("extra_info: ", extra_info);
            // this.entry_editable.id_cat = extra_info.id_cat;

            this.SelectCategoryById(extra_info.id_cat);
        }

        
        
        

        //change out prev input for entry first
    },

    //just to select the first one by default, or if loaded from before/ change the category
    async SelectCategoryByIndex(index:number)
    {
        let cats_ui = this.$refs.cats_ui as typeof ButtonGroupVue;
        cats_ui.SelectButton(index);
        

        //set the cat_id selected
        let extra_info = ((this.extra_info as any).entry as Entry)
        extra_info.id_cat = (this.btn_info_for_cats[index].extra_info as any).id_cat;

        this.entry_editable.id_cat= extra_info.id_cat;


        //need to also change out the auto complete/ prev input for entry and attributes
        //from: this.SetupForExistingEntry
        // this.previous_entries_in = 
        let prev_item_types_obj = await this.GetPrevEntriesForCat(this.entry_editable.id_cat);
        this.prev_item_types  = [...prev_item_types_obj];
        console.log("this.prev_item_types changed to: ", this.prev_item_types);

        // console.log("DEBUG CAT ENTRIES, Data.cats[1].entries : ",Data.cats[1].entries );
        
        //also for previous attributes:
        this.UpdatePrevAttributesForCat();

        // console.log("DEBUG CAT ENTRIES, Data.cats[1].entries : ",Data.cats[1].entries );
    },
    async SelectCategoryById(id_cat:string)
    {
        //have to figure out what index it is at, and select it that way
        let index_cat = -1;
        for (let i = 0; i < this.btn_info_for_cats.length; i++) {
            const element = this.btn_info_for_cats[i];
            if((element.extra_info as any).id_cat == id_cat)
            {
                index_cat= i;
                break;
            }            
        }
        if(index_cat==-1)
        {
            console.error("SelectCategoryById: didn't find cat! id_cat: ", id_cat, "this.btn_info_for_cats: ", this.btn_info_for_cats);
        }
        await this.SelectCategoryByIndex(index_cat);
    },
    HasDurationChanged(extra_info:any)
    {
        let btn = (extra_info as any).btn as typeof Button;

        //reset the time to now
        
        // console.log("HasDurationChanged! ", extra_info);

        // console.log("btn: ",btn, "selected: ", btn.selected);
        if(btn.selected)
        {
            
            this.has_duration=true;
            this.DateFinishedChanged(new Date());
            // this.date_finished = new Date() as unknown as undefined;
        }
        else
        {
            
            this.has_duration=false;
            // this.date_finished=undefined;
            this.DateFinishedChanged(undefined as any);
            console.log("Entry Editable: HasDurationChanged, date finished: ", this.date_finished);
        }
    },
    StartTracking(extra_info:any)
    {
        this.tracking=!this.tracking;
        console.log("this tracking: ", this.tracking);

        this.ElapsedTime(); //figure out how much time has elapsed
        // let btn = (extra_info as any).btn as typeof Button;

        // if(btn.selected)
        // {
        //     this.has_duration=true;
        //     this.date_finished = new Date() as unknown as undefined;
        // }
        // else
        // {
        //     this.has_duration=false;
        //     this.date_finished=undefined;
        // }
    },
    EnterHit()
    {
        //focus on the submit button if it doesn't have focus, and submit if it does
        let btn_submit = (this.$refs.submit as typeof Button);
        btn_submit.Focus();
        // (this.$refs.text as HTMLInputElement).focus();
    },

    //called from inputtextsmart, to let us know which previous entry was clicked, so we can create a new one with that value
    PrevEntryClickedCallBack(item_selected:any)
    {
        console.log("PrevEntryClickedCallBack, item_selected: ", item_selected)
        
        // this.entry_inputs.forEach((input,i) => {
        //     input.key=i+1;
        // });
        // this.entry_inputs.unshift({key:0, entry:item_selected});
        // if(this.entry_inputs.length==1)
            // this.entry_inputs.unshift({key:Date.now(), entry:item_selected});
        // if(this.entry_inputs.length==1)
            this.entry_inputs.splice(this.entry_inputs.length-1,0,{key:Date.now(), entry:item_selected});
        // else
        // this.entry_inputs.push({key:Date.now(), entry:item_selected});
            
        // else
        //     this.entry_inputs.push({key:Date.now(), entry:item_selected});

        console.log("this.entry_inputs: ", this.entry_inputs);
        
        // this.entry_inputs = this.entry_inputs.map(item=>{return item;});
    },
    NewInput()
    {
        //collapse previous inputs:
        let inputs = (this.$refs.text as typeof InputTextSmart);
        inputs.forEach((input:any)=>{
            input.CollapsePrevEntries();

        });

        this.entry_inputs.push({key:this.entry_inputs.length-1, entry:null})
        // this.entry_inputs.push({key:Date.now(), entry:null})
    },
    
    //for when a cat gets updated/ added through catedit- need to update the cats here, in the sub compnent entryel->entry editable
    //from entry list
    // async UpdateCatsAfterAddOrUpdate(cat_updated:CategoryData)
    // {
    // }


  },
  watch : 
  {
    extra_info:async function(extra_info_new) 
    {
        console.log("EntryEditable extra_info changed", extra_info_new, "extra_info_new.cat_changed: ", extra_info_new.cat_changed);
        //check if editcat screen changed a cat, and refresh if so
        if(extra_info_new.cat_changed)
        {
            console.log("EntryEditable cat changed, updating key!");
            //have to update btn_info_for_cats
            await this.SetupCategories();
            
            
            //update the cat area
            this.key_force_cat_update++;

            //also select the new cat created
            this.$nextTick(async ()=>{
                console.log("Entry editable, selecting cat: ", extra_info_new.cat,", with id: ", extra_info_new.cat.id);
                await this.SelectCategoryById(extra_info_new.cat.id);
            });
        }
        else
            console.log("EntryEditable no cat change");
    },  
    cats:async function(new_cats) 
    {
        console.log("EntryEditable cats changed", new_cats);
        await this.SetupCategories();
        //update the cat area
        this.key_force_cat_update++;

        //also select the new cat created
        this.$nextTick(async ()=>{
            console.log("Entry editable, selecting cat: ");
            await this.SelectCategoryByIndex(0);
        });
    }
  },


})
</script>

<template>
    <div  v-if="loaded" style="position: relative; width:100%">

    <div class="btn_group">       
        
        <Button type="no" :callback="()=>{StopEditing()}"  color_bg="var(--grey2)" color_bg2="var(--grey1)" color_txt="var(--greyF)" class="close" padding="5px 5px"/>
        <Button type="delete" :callback="DeleteClicked" :extra_info="extra_info" color_bg="red" v-if="!is_new_entry" padding="5px 5px" />
        <Button type="yes" :callback="EditSubmitted" :extra_info="extra_info" ref="submit" padding="5px 5px" />
        
    </div>
    <div v-if="cats_for_new_entry" class="categories" :key="key_force_cat_update">
        <ButtonGroupVue :button_info="btn_info_for_cats" :Changed="CategoryChanged" ref="cats_ui"/>
        <!-- <Button v-for=" cat in cats_for_new_entry" :text="cat.name" :icon="cat.icon" /> -->
        <!-- Also have one to add a new category, on another screen -->
    </div>
  
        
    <div class="entry_input">


        <InputTextSmart :default_value="entry.item_type" placeholder="Enter an Entry" 
        
            v-for="new_entry in entry_inputs" :key="new_entry.key"
            
            ref="text"
            :TextChanged="EntryNameChanged"
            :Submit="EnterHit"
            :previous_entries_in="prev_item_types as Array<any>" 
            :show_submit_btn="false"


            :PrevEntryClickedCallBack="PrevEntryClickedCallBack"
           
            
            :entry="new_entry.entry as unknown as Object"
        />

        <!-- for going into the textboxes, to have delete/ other button to the right of the textbox -->
        <!-- <Button type="delete" :callback="()=>{}" :extra_info="extra_info" color_bg="red" v-if="true" padding="5px 5px" /> -->

        <!-- <input type="text" :value="entry.item_type" ref="text" @keyup.enter="()=>{EditSubmitted(extra_info)}"/> -->

        <!-- Have one just for typing in new objects -->
        <!-- <InputTextSmart :default_value="entry.item_type" placeholder="Enter an Entry" 
        
            :key="Date.now()"
            
            ref="text"
            :TextChanged="EntryNameChanged"
            :Submit="EnterHit"
            :previous_entries_in="prev_item_types as Array<any>" :show_submit_btn="false"


            :PrevEntryClickedCallBack="PrevEntryClickedCallBack"
           
            
            :entry="new_entry.entry as unknown as Object"
        /> -->
        
        
    </div>
    <div>
        <Button v-if="is_new_entry" type="" icon="add" :callback="()=>{NewInput()}"  color_bg="var(--grey2)" color_bg2="var(--grey1)" color_txt="var(--greyF)" class="close"/>
        <Button v-if="is_new_entry&&entry_inputs.length>1" type="" icon="remove" :callback="()=>{entry_inputs.splice(entry_inputs.length-1,1)}"  color_bg="var(--grey2)" color_bg2="var(--grey1)" color_txt="var(--greyF)" class="close"/>
    </div>
    <div class="tracking">
        <Button v-if="!tracking" text="Start Tracking" type="yes" :callback="StartTracking" icon_dir="row" :wrap_txt="false"/>
        <Button v-else text="Cancel Tracking" type="no" :callback="StartTracking" icon_dir="row" :wrap_txt="false"/>
        <Button text="Finish Task?" type="check"  :checked="(date_finished!=undefined)" :callback="HasDurationChanged"  icon_dir="row" :wrap_txt="false"/>
    </div>
    <div class="timedates">
        <div>
            <p>Date<br/>Start:</p>
            <div class="timedate">
                <DatePicker :date_in="date_updated" :onDateChanged="DateStartedChanged"/>
                <TimePicker :date_in="date_updated" :onTimeChanged="DateStartedChanged"/>
            </div>
        </div>
        <div v-if="date_finished || has_duration">
            <p>Date<br/>End:</p>
            <div class="timedate">
                <DatePicker :date_in="date_finished" :onDateChanged="DateFinishedChanged"/>
                <TimePicker :date_in="date_finished" :onTimeChanged="DateFinishedChanged"/>
            </div>
        </div>
        <div v-if="tracking">
            <span>Elapsed Time: {{ elapsed_time }}</span>
        </div>
    </div>



    
    
    
<!-- SHould also have a list of attributes-->
    <div>
    <p>
        Attributes:
    </p>
    <div class="attributes" :key="force_vue_update_on_attr">
        <AttributeVue v-for="(attr2, index) in attributes" class="attribute"  ref="attributes" :attr="attr2" :prev_attributes="prev_attributes"
        :ShowModal="ShowModal"
        :entry="entry"
        :index="index"
        :DeleteAttribute="DeleteAttribute"
        
        
        
        />
        <!-- :key="force_vue_update_on_attr" -->
        <!-- <div v-for="(attr, index) in prev_attributes" class="attribute" :key="force_vue_update_on_attr" ref="attributes">
            <InputTextSmart ref="name" class="name" :default_value="attr.name" :show_submit_btn="false" placeholder="Enter an attribute name" :TextChanged="(text:string)=>{AttributeNameChanged(text, attr)}"  :previous_entries_in="prev_attr_names"/>
            <InputTextSmart ref="value" :default_value="attr.value" :show_submit_btn="false" placeholder="Enter an attribute value" :TextChanged="(text:string)=>{AttributeValueChanged(text, attr)}"  :previous_entries_in="prev_attr_values"/>
            <select  ref="rating" v-if="attr.rating>-1">
                <option value="-1">rating</option>
                <option value="0">0</option>
                <option value="1">1</option>
            </select>
        </div> -->
    </div>
    <div>
        <Button class="btn_add_attr" :callback="AddAttributeClicked" :extra_info="extra_info" text="Add New Attribute" />
    </div>
    </div>
    


</div>
</template>

<style scoped>
* {
    font-size:18px;
}
.entry_input
{
    display:flex;
    /* justify-content: stretch; */
    gap: 10px;
    flex-direction: column;
    /* flex-wrap: wrap; */
}


.entry_input > *:nth-child(2) > *
{
    /* width:100%;
    aspect-ratio: unset; */
}
/* 
.entry_input input[type="text"]
{
    flex-basis: 80%;
    width:100px;
} */
.entry_input button
{
    margin:0;
    aspect-ratio: 1;
}




.timedates
{
    display: flex; 
    gap: 20px; 
    margin-top:20px; 
    margin-bottom:20px;
    flex-wrap: wrap;
}
.timedates >*
{
    margin:0 auto;
}
/* .timedates > *:nth-child(2)
{
    border-left: 1px solid white; padding-left:20px;
} */
.timedates > div
{
    display: flex;
    gap: 0 10px;
    align-items: center;
}
.timedates p
{
    font-size: 20px;
    color:var(--color-heading);
}
.timedates input
{
    font-size:20px;
}
.timedate
{
    display: flex;
    flex-wrap:wrap;
    gap:10px;
    justify-content: center;
    flex-direction: column;
}
.tracking
{
    display:flex;
}
.tracking button
{
    width:100%;
}
.btn_group
{
    
    display: flex;    
    flex-direction: row;
    gap: 0 20px;
    position: sticky;
    z-index: 99;
    top:0;

    justify-content: space-around;
}
.btn_group button
{
    width:100% !important;
    aspect-ratio: unset;
    margin:0;
    /* margin-bottom:20px; */
}
.attributes
{
    display:flex;
    flex-direction: column;
    gap:20px;
}
.btn_add_attr
{
    min-height:.5in;
    margin:0;
    margin-top:20px;
}

.categories
{
    margin:10px 0;
}
.categories >div
{
    /* for horizontal scrolling */
    /* overflow-x: auto; */
    display: flex;

    
    
    scrollbar-width: thin;
    padding:2px;

    /* for vertical scrolling */
    flex-wrap: wrap;
    height:15vh;
    min-height:175px;
    /* height:25vh; */
    overflow-y: auto;
    

}
/* Nothing I do can affect the buttons in here- so going to have to manually change them directly in their component */
/* .categories button
{
    background:red;
    margin:0 !important;
    height:200px;
} */

/* Desktop */
@media only screen and (min-device-width: 768px)
{
    /* .entry_input > *:nth-child(1)
    {
        
        flex: 1 0 0;
    }
    .entry_input > *:nth-child(2)
    {
        
        flex:0 0 .5in;
    } */
    .entry_input *
    {
        min-width:.5in;
        min-height:.5in;
    }

    /* .entry_input > *:nth-child(1)
    {

        width:calc(100% - .5in - 10px);
    }
    .entry_input > *:nth-child(2)
    {

        position: absolute;
        top:0;
        right:0;
    }
    .entry_input > *:nth-child(2) > *
    {
        width:auto;
        aspect-ratio: 1;
    } */
    /* to get it to work with hover effect */
    /* .close
    {
    } */
    .entry_input
    {
        display: block;
    }
    /* .btn_group
    {
        
        gap:20px;
        flex-direction: row;
    }
    .btn_group button
    {
        width:50%;
    } */
}
</style>